import React from 'react';
import Whiteboard from '../components/whiteboard/Whiteboard';

const Room = () => {
  return <Whiteboard />;
};

export default Room;  // Make sure it's exported as default